var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5-polish-redirect",attrs:{"role":"status","aria-live":"polite"}},[_c('i',{staticClass:"el-icon-loading"}),_c('span',[_vm._v("正在打开润色改写…")])])
}]

export { render, staticRenderFns }